import { ICustomLookupColumn, ICustomLookupOptions } from '../constants';
import { DEFAULT_SEARCH_SCREEN_DIALOG_STYLE } from './customLookupDefaults.contants';
export const LOOKUP_COLUMNS: ICustomLookupColumn[] = [
    {
        dataField: 'CreditReason',
        caption: 'Credit reason',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false,
        allowSorting: true,
    },
    {
        dataField: 'Description',
        caption: 'Description',
        allowResizing: true,
        minWidth: 200,
        fixed: false,
        allowSorting: true,
    },
    {
        dataField: 'ReturnToStock',
        caption: 'Return to stock',
        allowResizing: true,
        minWidth: 120,
        width: 120,
        fixed: false
    },
    {
        dataField: 'MovementType',
        caption: 'Movement type',
        allowResizing: true,
        minWidth: 120,
        width: 120,
        fixed: false
    },
];

export const CustomerCreditReasonConstants: ICustomLookupOptions = {
    columns: LOOKUP_COLUMNS,
    dialogStyle: { ...DEFAULT_SEARCH_SCREEN_DIALOG_STYLE, width: '43rem' },
    hideColumnHeaders: false,
    disableGridColumnLines: false,
    dataPrefix: 'Details',
    dataGridSorting: 'multiple'
};
